
export interface JwtPayload {
    [key: string]: unknown;
    exp?: number;
    iat?: number;
    nbf?: number;
    sub?: string;
    iss?: string;
    aud?: string | string[];
    jti?: string;
}

export const decodeJwt = (token: string | null | undefined): JwtPayload | null => {
    if (!token || typeof token !== 'string' || token.trim().length === 0) {
        return null;
    }

    try {
        const parts = token.split('.');
        if (parts.length !== 3) {
            return null;
        }

        const base64Url = parts[1];
        if (!base64Url) {
            return null;
        }

        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

        const jsonPayload = typeof window === 'undefined'
            ? Buffer.from(base64, 'base64').toString('utf-8')
            : new TextDecoder('utf-8').decode(
                Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))
            );

        if (!jsonPayload) {
            return null;
        }

        const payload = JSON.parse(jsonPayload) as JwtPayload;
        return payload;
    } catch (error) {
        return null;
    }
};